import Splide from '@splidejs/splide';

const _slider = document.getElementById('gallery-carousel');

if (_slider) {
    let options = {
        type: 'slide',
        arrows: true,
        perPage: 3,
        perMove: 1,
        gap: 30,
        breakpoints: {
            768: {
                perPage: 2,
                perMove: 1,
            },
            575: {
                perPage: 1,
                perMove: 1,
            },
        },
    }

    let optionsWithRTL = {
        ...options,
        direction: 'rtl',
    }

    if(document.querySelector('link[href*="rtl.css"]')) {
        const mySlider = new Splide( _slider, optionsWithRTL);
        mySlider.mount();
    } else {
        const mySlider = new Splide( _slider, options);
        mySlider.mount();
    }
}